module.exports = __webpack_public_path__ + "fonts/Inter-Regular.9cd7588.ttf";